<script lang="ts" setup>
defineProps<{
  value: string
}>()
</script>

<template>
  <MDC
    :value
    class="mdc
      [&>h1]:heading1 [&>h2]:heading2 [&>h3]:heading3 [&>h4]:heading4 [&>h5]:heading5 [&>h6]:heading6
      [&>span]:paragraph-md [&>p]:paragraph-md [&>ol]:paragraph-md [&>ul]:paragraph-md [&>table]:paragraph-md

      [&>p]:mb-4 [&>ul]:mb-4 [&>ol]:mb-4
      [&_strong]:font-semibold

      [&_a]:underline [&_a]:text-blue-600 [&_a]:transition-colors [&_a]:duration-200
      [&_a:hover]:text-blue-800 [&_a:hover]:underline-offset-2
      [&_a:focus]:outline [&_a:focus]:outline-2 [&_a:focus]:outline-blue-300 [&_a:focus]:outline-offset-2
      dark:[&_a]:text-blue-400 dark:[&_a:hover]:text-blue-300 dark:[&_a:focus]:outline-blue-500

      [&>ul]:list-disc [&>ul]:pl-4
      [&>ol]:list-decimal [&>ol]:pl-4

      [&>blockquote]:border-l-4 [&>blockquote]:border-gray-200 dark:[&>blockquote]:border-gray-700
      [&>blockquote]:pl-4 [&>blockquote]:my-4 [&>blockquote]:text-gray-500 dark:[&>blockquote]:text-gray-400

      [&_code]:font-mono [&_code]:text-sm [&_code]:bg-gray-100 dark:[&_code]:bg-gray-800
      [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:rounded dark:[&_code]:text-gray-300
      [&>pre]:bg-gray-100 dark:[&>pre]:bg-gray-800 [&>pre]:p-4 [&>pre]:rounded [&>pre]:overflow-auto
      [&>pre]:mb-4 dark:[&>pre]:text-gray-300
      [&>pre>code]:bg-transparent [&>pre>code]:p-0 [&>pre>code]:block

      [&>table]:border-collapse [&>table]:w-full [&>table]:mb-4
      [&>table_th]:border [&>table_th]:border-gray-200 dark:[&>table_th]:border-gray-700
      [&>table_th]:p-2 [&>table_th]:text-left [&>table_th]:bg-gray-50 dark:[&>table_th]:bg-gray-800
      [&>table_th]:font-semibold dark:[&>table_th]:text-gray-200
      [&>table_td]:border [&>table_td]:border-gray-200 dark:[&>table_td]:border-gray-700
      [&>table_td]:p-2 dark:[&>table_td]:text-gray-200
      [&>table_tr:nth-child(even)]:bg-gray-50 dark:[&>table_tr:nth-child(even)]:bg-gray-800
      dark:[&>table_tr:nth-child(odd)]:bg-gray-900"
    tag="div"
  />
</template>

<style scoped>
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 0.5rem;
}

.mdc p, .mdc ul, .mdc ol{
  margin-bottom: 1em;
}
.mdc strong{
  font-weight: 600;
}
.mdc a{
  text-decoration: underline;
}
.mdc ul{
  list-style-type: disc;
  padding-left: 1em;
}
.mdc ol{
  list-style-type: decimal;
  padding-left: 1em;
}
</style>
